import React, {useMemo} from "react";
import {Paper} from "@mui/material";
import AddressCard from "../../address-card";
import {Col} from "reactstrap";

const OrderInformationViewReadOnlyAddressesSection = ({billing, shipping, loading}) => {

    const shippingAddress = useMemo(() => !shipping
            ? undefined
            : ({
                ...shipping,
                streetAddress: shipping?.fullAddress,
                title: "Shipping Address"
            })
        , [shipping])

    const billingAddress = useMemo(() => !billing
            ? undefined
            : ({
                ...billing,
                streetAddress: billing?.fullAddress,
                title: "Billing Address"
            })
        , [billing])

    return (
        <>
            <Paper className='paper w-100 p-4'>
                <div className={'d-flex w-100 flex-wrap'} style={{gap: 16}}>
                    {
                        loading &&
                        Array(2).fill(null).map((_, e) => (
                            <Col key={e} xs={12} md={6} xl={4} className={'loading extraLarge'}>
                                <div/>
                            </Col>
                        ))
                    }
                    {
                        !loading && shippingAddress &&
                        <AddressCard
                            readonly
                            address={shippingAddress}
                        />
                    }
                    {
                        !loading && billingAddress &&
                        <AddressCard
                            readonly
                            address={billingAddress}
                        />
                    }
                </div>
            </Paper>
        </>
    )
}

export default OrderInformationViewReadOnlyAddressesSection;
